:host{display:flex;gap:4px}
/*# sourceMappingURL=layer-view-settings.component.css.map */
